import EditableTextField from 'components/forms/inputs/EditableTextField';
import React from 'react';
import { useUpdateInvoiceClientReferenceMutation } from 'store/api/invoices';

interface EditableInvoiceClientReferenceProps {
    invoiceId: number;
    clientReference: string | undefined | null;
    isEditEnabled: boolean;
}

const EditableInvoiceClientReference: React.FC<EditableInvoiceClientReferenceProps> = ({
    invoiceId,
    clientReference,
    isEditEnabled,
}) => {
    const [updateInvoiceClientReference] = useUpdateInvoiceClientReferenceMutation();

    const handleSave = async (newValue: string) => {
        await updateInvoiceClientReference({
            id: invoiceId,
            value: newValue || null,
        }).unwrap();
    };

    return (
        <EditableTextField
            placeholder={'-'}
            value={clientReference}
            onSave={handleSave}
            isEditEnabled={isEditEnabled}
        />
    );
};

export default EditableInvoiceClientReference;
